import { EstateLifeInsurances } from '@/modules/estate/EstateLifeInsurances/EstateLifeInsurances';

export function ClientEstateLifeInsurancePage() {
  return <EstateLifeInsurances />;
}
